import {Component, Inject} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';

@Component(
    {selector: 'edit-user-dialog', templateUrl: './edit-user-dialog.html'})
export class EditUserDialogComponent {
  email = new FormControl('', [
    Validators.pattern(
        '^[a-z0-9!#$%&\'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$'),
    Validators.required
  ]);
  name = new FormControl('', [Validators.required]);

  constructor(
      public dialogRef: MatDialogRef<EditUserDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any) {
    this.data.twoFactorForceSelection = this.getTwoFactorForceSelection();
  }

  getErrorMessage() {
    return this.email.hasError('required') ?
        'You must enter an email' :
        this.email.hasError('pattern') ? 'Not a valid email' : '';
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onTwoFactorPolicyChange(value: string) {
    if (value === 'inherit') {
      this.data.response['2fa'] = null;
      return;
    }

    this.data.response['2fa'] = {
      force: value === 'required'
    };
  }

  onRoleChange() {
    if (this.data.response.role === 'appuser') {
      this.data.twoFactorForceSelection = 'inherit';
      this.data.response['2fa'] = null;
    }
  }

  private getTwoFactorForceSelection(): string {
    if (!this.data.response['2fa'] || this.data.response['2fa'].force === undefined || this.data.response['2fa'].force === null) {
      return 'inherit';
    }

    return this.data.response['2fa'].force ? 'required' : 'not_required';
  }
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/users/edit/edit.user.dialog.component.ts